module.exports = __webpack_public_path__ + "img/banner.5e826403.png";